import noop from 'lodash/noop';
import { createActions } from 'redux-actions';

export const transferToAgentActions = createActions(
  {
    TRANSFER_TO_AGENT_ASSISTED_REQUEST: [
      (payload: any) => payload,
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    TRANSFER_TO_AGENT_BLIND_REQUEST: [
      (payload: any) => payload,
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    TRANSFER_TO_AGENT_ASSISTED_RESOLVE: [
      (payload: any) => payload,
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
  },

  'TRANSFER_TO_AGENT_ASSISTED_REQUEST_SUCCEEDED',
  'TRANSFER_TO_AGENT_ASSISTED_REQUEST_FAILED',

  'TRANSFER_TO_AGENT_BLIND_REQUEST_SUCCEEDED',
  'TRANSFER_TO_AGENT_BLIND_REQUEST_FAILED',

  'TRANSFER_TO_AGENT_ASSISTED_RESOLVE_SUCCEEDED',
  'TRANSFER_TO_AGENT_ASSISTED_RESOLVE_FAILED',

  'TRANSFER_TO_AGENT_MODAL_CLOSE',
  'TRANSFER_TO_AGENT_MODAL_OPEN',
  'TRANSFER_TO_AGENT_MODAL_OPEN_BY_CSID',

  'TRANSFER_TO_AGENT_REQUEST_STOP',

  'TRANSFER_TO_AGENT_SHOW_MESSAGE_MODAL',
  'TRANSFER_TO_AGENT_HIDE_MESSAGE_MODAL',

  //Should this be moved to WS?
  'TRANSFER_TO_AGENT_WS_RESPONSE',
  'TRANSFER_TO_AGENT_WS_TRANSFER_STARTED',
  'TRANSFER_TO_AGENT_WS_TRANSFER_ANSWERED',
);
